









import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class Columns extends Vue {
  @Prop({ default: false })
  public readonly isMarginless!: boolean;
  @Prop({ default: true })
  public readonly isMultiline!: boolean;
}
